export const GALLERY_LIGHTBOX = {
  init: function (elements) {
    const $elements = $(elements)
    $elements.each((index, element) => {
      $(element)
        .find('a')
        // .attr('data-lightbox', `group-${index + 1}`)
        .attr('data-lightbox', 'gallery')
    })
  },
}
